export enum InputTypes {
  Text = 'text',
  Password = 'password'
}